import { render, staticRenderFns } from "./HelpFrame.vue?vue&type=template&id=1c0083c2&scoped=true"
import script from "./HelpFrame.vue?vue&type=script&lang=js"
export * from "./HelpFrame.vue?vue&type=script&lang=js"
import style0 from "./HelpFrame.vue?vue&type=style&index=0&id=1c0083c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0083c2",
  null
  
)

export default component.exports